import React, { useEffect, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import Navbar from '../Navbar';
import Footer from '../Footer';
import LoyaltyProductModal from './LoyaltyProductModal';
import axios from 'axios';
import { FaRegEdit, FaSave } from "react-icons/fa";
import { MdDeleteOutline, MdCancel } from 'react-icons/md';
import { toast } from 'react-toastify';
import OutletSearch from '../SelectSearch/OutletSearch';

const AddCustomerLoyalty = () => {
    let url = process.env.REACT_APP_BASE_URL;
    const token = localStorage.getItem("token");
    const [selectedOutlet, setSelectedOutlet] = useState(null);
    const [modalShow, setModalShow] = useState(false);
    const [loyaltyData, setLoyaltyData] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [editFormData, setEditFormData] = useState({});

    const [formData, setFormData] = useState({
        product: '',
        points: '',
        valid_until: '',
        is_menu_item_flag: false,
        description: '',
        image: null,
    });

    const showToast = (message, type = 'success') => {
        if (type === 'success') {
            toast.success(message);
        } else {
            toast.error(message);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        if (type === 'file') {
            setFormData((prev) => ({ ...prev, [name]: files[0] }));
        } else if (type === 'checkbox') {
            setFormData((prev) => ({ ...prev, [name]: checked }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append('token', token);
        data.append('outlet', selectedOutlet);
        data.append('product', formData.product);
        data.append('points', formData.points);
        data.append('valid_until', formData.valid_until);
        data.append('is_menu_item_flag', formData.is_menu_item_flag);
        data.append('description', formData.description);
        if (formData.image) {
            data.append('image', formData.image);
        }

        try {
            const response = await fetch(`${url}/add-redeemable-product`, {
                method: 'POST',
                body: data,
            });
            const result = await response.json();

            if (response.ok) {
                showToast('Product added successfully!');
                setModalShow(false);
                const updatedResponse = await axios.post(`${url}/get-redeemable-product`, {
                    token: token,
                    outlet: selectedOutlet
                });
                setLoyaltyData(updatedResponse.data.redeemable_products);
            } else {
                showToast(result.message || 'Failed to add product', 'error');
            }
        } catch (error) {
            console.error('Error:', error);
            showToast('An error occurred while adding the product', 'error');
        }
    };


    const handleEditClick = (item) => {
        setEditingId(item.id);
        setEditFormData({
            product: item.product,
            points: item.points,
            valid_until: item.valid_until,
            is_menu_item_flag: item.is_menu_item_flag,
            description: item.description,
            image: null,
            existingImage: item.image
        });
    };

    const handleEditChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        if (type === 'file') {
            setEditFormData(prev => ({ ...prev, image: files[0] }));
        } else if (type === 'checkbox') {
            setEditFormData(prev => ({ ...prev, [name]: checked }));
        } else {
            setEditFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleCancelEdit = () => {
        setEditingId(null);
        setEditFormData({});
    };

    const handleUpdate = async (id) => {
        const data = new FormData();
        data.append('token', token);
        data.append('outlet', selectedOutlet);
        data.append('product', editFormData.product);
        data.append('points', editFormData.points);
        data.append('valid_until', editFormData.valid_until);
        data.append('is_menu_item_flag', editFormData.is_menu_item_flag);
        data.append('description', editFormData.description);
        if (editFormData.image) {
            data.append('image', editFormData.image);
        }

        try {
            await axios.put(`${url}/update-redeemable-product/${id}`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            showToast('Product updated successfully!');
            const updatedResponse = await axios.post(`${url}/get-redeemable-product`, {
                token: token,
                outlet: selectedOutlet
            });
            setLoyaltyData(updatedResponse.data.redeemable_products);
            setEditingId(null);
        } catch (error) {
            console.error('Failed to update loyalty product', error);
            showToast(error.response?.data?.message || 'Failed to update product', 'error');
        }
    };

    const confirmDeleteToast = (onConfirm) => {
        const ToastContent = ({ closeToast }) => (
            <div>
                <p>Are you sure you want to delete this product?</p>
                <div className="mt-2 flex justify-end gap-2">
                    <button
                        className="bg-gray-300 px-3 py-1 rounded hover:bg-gray-400"
                        onClick={closeToast}
                    >
                        Cancel
                    </button>
                    <button
                        className="bg-red-500 px-3 py-1 text-white rounded hover:bg-red-600"
                        onClick={() => {
                            onConfirm();
                            closeToast();
                        }}
                    >
                        Delete
                    </button>
                </div>
            </div>
        );

        toast.info(<ToastContent />, {
            autoClose: true,
            closeOnClick: false,
            draggable: false,
        });
    };

    const handleDelete = async (id) => {
        confirmDeleteToast(async () => {
            try {
                await axios.delete(`${url}/delete-redeemable-product/${id}`, {
                    data: { token: token },
                });
                toast.success('Product deleted successfully!');
                const updatedResponse = await axios.post(`${url}/get-redeemable-product`, {
                    token: token,
                    outlet: selectedOutlet,
                });
                setLoyaltyData(updatedResponse.data.redeemable_products);
            } catch (error) {
                console.error('Failed to delete loyalty product', error);
                toast.error(error.response?.data?.message || 'Failed to delete product');
            }
        });
    };

    useEffect(() => {
        if (token && selectedOutlet) {
            const fetchLoyalty = async () => {
                try {
                    const response = await axios.post(`${url}/get-redeemable-product`, {
                        token: token,
                        outlet: selectedOutlet
                    });
                    setLoyaltyData(response.data.redeemable_products);
                } catch (error) {
                    console.error('Failed to fetch loyalty products:', error);
                    showToast('Failed to load products', 'error');
                }
            };
            fetchLoyalty();
        }
    }, [token, selectedOutlet]);

    return (
        <div className="flex flex-col min-h-screen">
            <Navbar />

            <div className="flex-grow p-6">
                <div className="flex justify-center mb-4">
                    <OutletSearch
                        token={token}
                        setSelectedOutlet={setSelectedOutlet}
                        selectedOutlet={selectedOutlet}
                    />
                </div>

                <div className="flex justify-center">
                    <Button onClick={() => setModalShow(true)}>Add Loyalty Product</Button>
                </div>

                <LoyaltyProductModal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    formData={formData}
                />

                {loyaltyData && loyaltyData.length > 0 && (
                    <div className="mt-4 max-w-7xl mx-auto">
                        <h4 className="text-center mb-4 text-xl font-bold">Redeemable Products</h4>
                        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
                            {loyaltyData.map((item) => (
                                <div key={item.id} className="h-full">
                                    <Card className="h-full flex flex-row p-1 shadow-md hover:shadow-lg transition-shadow">
                                        <div className="w-52 h-52 flex-shrink-0 relative">
                                            {editingId === item.id ? (
                                                <>
                                                    <Card.Img
                                                        src={
                                                            editFormData.image
                                                                ? URL.createObjectURL(editFormData.image)
                                                                : `${url}/${editFormData.existingImage}`
                                                        }
                                                        alt={editFormData.product}
                                                        className="w-full h-full object-cover rounded-l"
                                                    />
                                                    <input
                                                        type="file"
                                                        name="image"
                                                        onChange={handleEditChange}
                                                        className="absolute bottom-2 left-2 text-xs"
                                                    />
                                                </>
                                            ) : (
                                                <Card.Img
                                                    src={`${url}/${item.image}`}
                                                    alt={item.product}
                                                    className="w-full h-full object-cover rounded-l"
                                                />
                                            )}
                                        </div>
                                        <Card.Body className="p-4 flex-grow flex flex-col">
                                            <div className="flex justify-between items-start">
                                                {editingId === item.id ? (
                                                    <input
                                                        type="text"
                                                        name="product"
                                                        value={editFormData.product}
                                                        onChange={handleEditChange}
                                                        className="text-lg font-bold text-gray-800 border rounded px-2 w-full"
                                                    />
                                                ) : (
                                                    <Card.Title className="text-lg font-bold text-gray-800">
                                                        {item.product}
                                                    </Card.Title>
                                                )}
                                                <div className="flex space-x-2">
                                                    {editingId === item.id ? (
                                                        <>
                                                            <button
                                                                onClick={() => handleUpdate(item.id)}
                                                                className="text-green-500 hover:text-green-700 transition-colors"
                                                            >
                                                                <FaSave size={18} />
                                                            </button>
                                                            <button
                                                                onClick={handleCancelEdit}
                                                                className="text-red-500 hover:text-red-700 transition-colors"
                                                            >
                                                                <MdCancel size={20} />
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <button
                                                                onClick={() => handleEditClick(item)}
                                                                className="text-blue-500 hover:text-blue-700 transition-colors"
                                                            >
                                                                <FaRegEdit size={18} />
                                                            </button>
                                                            <button
                                                                onClick={() => handleDelete(item.id)}
                                                                className="text-red-500 hover:text-red-700 transition-colors"
                                                            >
                                                                <MdDeleteOutline size={20} />
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                            </div>

                                            <Card.Text className="text-sm text-gray-600 mt-2 flex-grow">
                                                {editingId === item.id ? (
                                                    <textarea
                                                        name="description"
                                                        value={editFormData.description}
                                                        onChange={handleEditChange}
                                                        className="border rounded px-2 py-1 w-full mb-2"
                                                        rows="3"
                                                    />
                                                ) : (
                                                    <p className="mb-2">{item.description}</p>
                                                )}

                                                <div className="space-y-1">
                                                    <div className="flex items-center">
                                                        <span className="font-medium w-32">Points to redeem:</span>
                                                        {editingId === item.id ? (
                                                            <input
                                                                type="number"
                                                                name="points"
                                                                value={editFormData.points}
                                                                onChange={handleEditChange}
                                                                className="border rounded px-2 w-20"
                                                            />
                                                        ) : (
                                                            <span className="text-gray-800 font-semibold">{item.points}</span>
                                                        )}
                                                    </div>
                                                    <div className="flex items-center">
                                                        <span className="font-medium w-32">Menu Item:</span>
                                                        {editingId === item.id ? (
                                                            <input
                                                                type="checkbox"
                                                                name="is_menu_item_flag"
                                                                checked={editFormData.is_menu_item_flag}
                                                                onChange={handleEditChange}
                                                                className="ml-2"
                                                            />
                                                        ) : (
                                                            <span className={item.is_menu_item_flag ? "text-green-600" : "text-gray-600"}>
                                                                {item.is_menu_item_flag ? 'Yes' : 'No'}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="flex items-center">
                                                        <span className="font-medium w-32">Valid Until:</span>
                                                        {editingId === item.id ? (
                                                            <input
                                                                type="date"
                                                                name="valid_until"
                                                                value={editFormData.valid_until ? editFormData.valid_until.split('T')[0] : ''}
                                                                onChange={handleEditChange}
                                                                className="border rounded px-2"
                                                            />
                                                        ) : (
                                                            <span className="text-gray-800">
                                                                {new Date(item.valid_until).toLocaleDateString().split('T')[0]}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

            </div>

            <Footer />

        </div>
    );
};

export default AddCustomerLoyalty;